export const dataWorkshopEntityId = {
  type: 'number',
};
